import {Component} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {ReportType} from '../../report-catalog';
import styles from './report-scheduler-data.module.scss';
import EnhancedActiveFleetComponent
    from './report-data-components/enhanced-active-fleet/enhanced-active-fleet.component';
import ExtendedInspectionComponent from './report-data-components/extended-inspection/extended-inspection.component';
import MasterFleetListComponent from './report-data-components/master-fleet-list/master-fleet-list.component';
import BreakdownListComponent from './report-data-components/breakdown-list/breakdown-list.component';
import {
    BreakdownAndServicesBillingScheduledReportParameters,
    BreakdownListScheduledReportParameters,
    DamagedTireDetailsScheduledReportParameters,
    DamagedTiresBillingScheduledReportParameters,
    EnhancedActiveFleetScheduledReportParameters,
    ExtendedInspectionScheduledReportParameters,
    ExtendedServiceScheduledReportParameters,
    InspectionDetailsScheduledReportParameters,
    InvoiceByJobScheduledReportParameters,
    InvoiceByVehicleScheduledReportParameters,
    InvoiceItemByVehicleScheduledReportParameters,
    EnhancedInvoiceItemByVehicleScheduledReportParameters,
    JobVerificationScheduledReportParameters,
    MasterFleetListScheduledReportParameters,
    MileageBillingScheduledReportParameters,
    MountedTireDetailsScheduledReportParameters, OdometerListScheduledReportParameters,
    RemovedAndFittedTiresScheduledReportParameters,
    ReportPeriodType,
    ScheduledReportParameters,
    TCUSensorFitmentsScheduledReportParameters,
    TireHistoryScheduledReportParameters,
    TirePerformanceScheduledReportParameters,
    TireStockCompany,
    TireStockScheduledReportParameters,
    UnbilledJobsScheduledReportParameters,
    UnmountedTiresScheduledReportParameters,
    VehicleJobListScheduledReportParameters,
    VehiclesCurrentStatusScheduledReportParameters,
    VehiclesDueForInspectionScheduledReportParameters,
} from '../../../../store/reports';
import DamagedTireDetailsComponent from './report-data-components/damaged-tires-details/damaged-tire-details.component';
import InvoiceByVehicleComponent from './report-data-components/invoice-by-vehicle/invoice-by-vehicle.component';
import MountedTireDetailsComponent from './report-data-components/mounted-tire-details/mounted-tire-details.component';
import RemovedAndFittedTiresComponent
    from './report-data-components/removed-and-fitted-tires/removed-and-fitted-tires.component';
import TireHistoryComponent from './report-data-components/tire-history/tire-history.component';
import UnmountedTireDetailsComponent from './report-data-components/unmounted-tires/unmounted-tire-details.component';
import VehicleJobListComponent from './report-data-components/vehicle-job-list/vehicle-job-list.component';
import VehiclesCurrentStatusComponent
    from './report-data-components/vehicles-current-status/vehicles-current-status.component';
import VehiclesDueForInspectionComponent
    from './report-data-components/vehicles-due-for-inspection/vehicles-due-for-inspection.component';
import ExtendedServiceComponent from './report-data-components/extended-service/extended-service.component';
import TireStockComponent from './report-data-components/tire-stock/tire-stock.component';
import InvoiceItemByVehicleComponent
    from './report-data-components/invoice-item-by-vehicle/invoice-item-by-vehicle.component';
import EnhancedInvoiceItemByVehicleComponent
    from './report-data-components/enhanced-invoice-item-by-vehicle/enhanced-invoice-item-by-vehicle.component';
import InspectionDetailsComponent from './report-data-components/inspection-details/inspection-details.component';
import UnbilledJobsComponent from './report-data-components/unbilled-jobs/unbilled-jobs.component';
import TirePerformanceComponent from './report-data-components/tire-performance/tire-performance.component';
import JobVerificationByInvoiceComponent from "./report-data-components/job-verification/job-verification.component";
import BreakdownAndServicesBillingComponent
    from "./report-data-components/breakdown-and-services-billing/breakdown-and-services-billing.component";
import TcuSensorFitmentsComponent from "./report-data-components/tcu-sensor-fitments/tcu-sensor-fitments.component";
import DamagedTiresBillingComponent
    from "./report-data-components/damaged-tires-billing/damaged-tires-billing.component";
import OdometerListComponent from "./report-data-components/odometer-list/odometer-list.component";

class ReportSchedulerDataComponent extends Component<AllProps, AllState> {

    public componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<AllState>, snapshot?: any) {
    }

    public render(): JSX.Element {
        const {reportType, parameters} = this.props;

        return (
            <div className={styles.container}>
                {reportType === ReportType.EnhancedActiveFleetList ? (
                    <EnhancedActiveFleetComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as EnhancedActiveFleetScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.ExtendedInspection ? (
                    <ExtendedInspectionComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as ExtendedInspectionScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.ExtendedService ? (
                    <ExtendedServiceComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as ExtendedServiceScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.MasterFleetList ? (
                    <MasterFleetListComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as MasterFleetListScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.BreakdownList ? (
                    <BreakdownListComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as BreakdownListScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.DamagedTireDetails ? (
                    <DamagedTireDetailsComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as DamagedTireDetailsScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.InvoiceByJob ? (
                    <InvoiceByVehicleComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as InvoiceByJobScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.InvoiceByVehicle ? (
                    <InvoiceByVehicleComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as InvoiceByVehicleScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.InvoiceItemByVehicle ? (
                    <InvoiceItemByVehicleComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as InvoiceItemByVehicleScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.EnhancedInvoiceItemByVehicle ? (
                    <EnhancedInvoiceItemByVehicleComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as EnhancedInvoiceItemByVehicleScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.MountedTireDetails ? (
                    <MountedTireDetailsComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as MountedTireDetailsScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.RemovedAndFittedTires ? (
                    <RemovedAndFittedTiresComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as RemovedAndFittedTiresScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.MileageBilling ? (
                    <RemovedAndFittedTiresComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as MileageBillingScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.BreakdownAndServicesBilling ? (
                    <BreakdownAndServicesBillingComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as BreakdownAndServicesBillingScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.DamagedTiresBilling ? (
                    <DamagedTiresBillingComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as DamagedTiresBillingScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.TireHistory ? (
                    <TireHistoryComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as TireHistoryScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.TireStock ? (
                    <TireStockComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as TireStockScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.TirePerformance ? (
                    <TirePerformanceComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as TirePerformanceScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.UnmountedTireDetails ? (
                    <UnmountedTireDetailsComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as UnmountedTiresScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.VehicleJobList ? (
                    <VehicleJobListComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as VehicleJobListScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.UnbilledJobs ? (
                    <UnbilledJobsComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as UnbilledJobsScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.VehiclesCurrentStatus ? (
                    <VehiclesCurrentStatusComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as VehiclesCurrentStatusScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.InspectionDetails ? (
                    <InspectionDetailsComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as InspectionDetailsScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.TCUSensorFitments ? (
                    <TcuSensorFitmentsComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as TCUSensorFitmentsScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.VehiclesDueForInspectionDetails ? (
                    <VehiclesDueForInspectionComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as VehiclesDueForInspectionScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.JobVerification ? (
                    <JobVerificationByInvoiceComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as JobVerificationScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
                {reportType === ReportType.OdometerList ? (
                    <OdometerListComponent
                        periodType={ReportPeriodType.Scheduled}
                        parameters={parameters as OdometerListScheduledReportParameters}
                        onCustomParametersChanged={() => {}}
                        onScheduledParametersChanged={(p) => this.onParametersChanged(p)}
                    />
                ) : ''}
            </div>

        );
    }

    private onParametersChanged(parameters: ScheduledReportParameters): void {
        const {onParametersChanged} = this.props;

        onParametersChanged(parameters);
    }

}

export default withTranslation()(ReportSchedulerDataComponent);

interface OwnProps {
    companies?: TireStockCompany[];
    reportType: ReportType
    parameters: ScheduledReportParameters;
    onParametersChanged: (parameters: ScheduledReportParameters) => void;
}

type AllProps = OwnProps & WithTranslation;

interface OwnState {

}

type AllState = OwnState;
